import Api from '@/services/api'
import SBPoll from '@/models/SBPoll'
import map from 'lodash/map'

export default {
  images_upload_handler: function (blobInfo, success, failure, progress) {
    var formData
    formData = new FormData()
    formData.append('image', blobInfo.blob(), blobInfo.filename())

    Api.post(`admin/editor-image`, formData)
      .then(response => {
        success(response.data.data.image_url)
      })
      .catch(error => {
        failure('Ooops! Something went wrong')
        console.error(error)
      })
  },
  content_css: '/css/tinymce_custom.css?cacheBuster=' + new Date().getTime(),
  image_dimensions: false,
  height: 500,
  menubar: false,
  browser_spellcheck: true,
  contextmenu: false,
  keep_styles: false,
  forced_root_block: '',
  force_p_newlines: true,
  force_br_newlines: false,
  plugins: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount'
  ],
  toolbar:
    'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | image media table link | code | fullscreen help hypometerWidgets hypometerFuturesWidget sbPollWidget',
  // 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | image media table link | code | fullscreen help',
  // formats: {
  //   h1: { block: 'h1', styles: { 'margin-bottom': '22px' } },
  //   h2: { block: 'h2', styles: { 'margin-bottom': '22px' } },
  //   h3: { block: 'h3', styles: { 'margin-bottom': '22px' } },
  //   h4: { block: 'h4', styles: { 'margin-bottom': '22px' } },
  //   h5: { block: 'h5', styles: { 'margin-bottom': '22px' } },
  //   h6: { block: 'h6', styles: { 'margin-bottom': '22px' } },
  //   p: { block: 'p', styles: { 'margin-bottom': '0px' } }

  // },
  extended_valid_elements: 'script[language|type|src]',
  media_url_resolver: function (data, resolve/*, reject*/) {
    console.log(data.url.includes('youtu.be'));

    var vId = data.url.split("/").pop();

    if((data.url.includes('youtu.be') ||data.url.includes('youtube')) && vId) {
      var embedUrl = 'https://www.youtube.com/embed/' + vId;
      var embedHtml = '<iframe src="' + embedUrl + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="aspect-ratio: 16 / 9 !important"></iframe>';
      resolve({html: embedHtml});
    } else {
      resolve({html: ''});
    }
  },
  setup: function (editor) {
    var _dialog = false
    var _futuresdialog = false

    var _typeOptions = []

    /**
     * Get the Dialog Configuration Object
     *
     * @returns {{buttons: *[], onSubmit: onSubmit, title: string, body: {}}}
     * @private
     */
    function _getDialogConfig () {
      return {
        title: 'Insert Hypometer Widget',
        body: {
          type: 'panel',
          items: [{
            type: 'selectbox',
            name: 'widgetType',
            label: 'Widget Type',
            items: _typeOptions,
            flex: true
          },
          {
            type: 'input',
            name: 'matchID',
            label: 'Match ID',
            flex: true
          }
          ]
        },
        onSubmit: function (api) {
          let widgetType = api.getData().widgetType
          let matchID = api.getData().matchID

          if (!matchID) {
            editor.windowManager.alert('Match ID is required.', function () { })
          } else {
            switch (widgetType) {
              case 'overall':
              case 'h2h':
              case 'line':
              case 'total':
              case 'parlay':
                editor.insertContent('<div data-widget="external-match-best-bet" data-widget-append="{&quot;matchID&quot;: &quot;' + matchID + '&quot;, &quot;betType&quot;: &quot;' + widgetType + '&quot;}"> </div>')
                break
              case 'external-pre-match-predictions':
              case 'external-match-page-header':
                editor.insertContent('<div data-widget="' + widgetType + '" data-widget-append="{&quot;matchID&quot;: &quot;' + matchID + '&quot;}"> </div>')
                break
              default:
                break
            }

            api.close()
          }
        },
        buttons: [
          {
            text: 'Close',
            type: 'cancel',
            onclick: 'close'
          },
          {
            text: 'Insert',
            type: 'submit',
            primary: true,
            enabled: false
          }
        ]
      }
    }

    /**
     * Plugin behaviour for when the Toolbar or Menu item is selected
     *
     * @private
     */
    function _onAction () {
      _dialog = editor.windowManager.open(_getDialogConfig())

      // block the Dialog, and commence the data update
      // Message is used for accessibility
      _dialog.block('Loading...')

      setTimeout(function () {
        // We're assuming this is what runs after the server call is performed
        // We'd probably need to loop through a response from the server, and update
        // the _typeOptions array with new values. We're just going to hard code
        // those for now.
        _typeOptions = [
          { text: 'Pre-Match Prediction', value: 'external-pre-match-predictions' },
          { text: 'Best Bets Over/Under(overall)', value: 'overall' },
          { text: 'Best Bets Moneyline', value: 'h2h' },
          { text: 'Best Bets Run Line', value: 'line' },
          { text: 'Best Bets Over/Under(total)', value: 'total' },
          { text: 'Best Bets Same Game Parlay', value: 'parlay' },
          { text: 'Match Page Header', value: 'external-match-page-header' }
        ]

        // re-build the dialog
        _dialog.redial(_getDialogConfig())

        // unblock the dialog
        _dialog.unblock()
      }, 500)
    }

    // HYPOMETER FUTURES WIDGET
    function _getFuturesDialogConfig () {
      return {
        title: 'Insert Hypometer Futures Widget',
        body: {
          type: 'panel',
          items: [
            {
              type: 'input',
              name: 'sportCode',
              label: 'Sport Code',
              flex: true
            }
          ]
        },
        onSubmit: function (api) {
          let sportCode = api.getData().sportCode ? api.getData().sportCode : 'NFL'

          editor.insertContent('<div data-widget="external-futures-mini" data-widget-append="{&quot;sportCode&quot;: &quot;' + sportCode + '&quot;}"> </div>')

          api.close()
        },
        buttons: [
          {
            text: 'Close',
            type: 'cancel',
            onclick: 'close'
          },
          {
            text: 'Insert',
            type: 'submit',
            primary: true,
            enabled: false
          }
        ]
      }
    }

    function _futureOnAction () {
      _futuresdialog = editor.windowManager.open(_getFuturesDialogConfig())

      // block the Dialog, and commence the data update
      // Message is used for accessibility
      _futuresdialog.block('Loading...')

      setTimeout(function () {
        // re-build the dialog
        _futuresdialog.redial(_getFuturesDialogConfig())

        // unblock the dialog
        _futuresdialog.unblock()
      }, 500)
    }

    async function _pollOnAction () {
      _futuresdialog = editor.windowManager.open(_getPollDialogConfig())

      // block the Dialog, and commence the data update
      // Message is used for accessibility
      _futuresdialog.block('Loading...')
      _typeOptions = []

      const query = SBPoll.params({ limit: 'all' })

      const tmpData = await query.get()
      const pollData = tmpData.data

      setTimeout(function () {
        map(pollData, p => {
          _typeOptions.push({
            'text': p.question,
            'value': p.id.toString()
          })
        })

        // re-build the dialog
        _futuresdialog.redial(_getPollDialogConfig())

        // unblock the dialog
        _futuresdialog.unblock()
      }, 500)
    }

    function _getPollDialogConfig () {
      return {
        title: 'Insert Poll',
        body: {
          type: 'panel',
          items: [{
            type: 'selectbox',
            name: 'poll',
            label: 'Poll',
            items: _typeOptions,
            flex: true
          }
          ]
        },
        onSubmit: function (api) {
          let poll = api.getData().poll

          if (!poll) {
            editor.windowManager.alert('Poll is required.', function () { })
          } else {
            editor.insertContent('<div data-widget="sb101-poll" data-widget-append="{&quot;pollId&quot;: &quot;' + poll + '&quot;}"> </div>')

            api.close()
          }
        },
        buttons: [
          {
            text: 'Close',
            type: 'cancel',
            onclick: 'close'
          },
          {
            text: 'Insert',
            type: 'submit',
            primary: true,
            enabled: false
          }
        ]
      }
    }

    // Define the Toolbar button
    editor.ui.registry.addButton('hypometerWidgets', {
      text: 'Hypometer Widgets',
      onAction: _onAction
    })

    // Define the Menu Item
    editor.ui.registry.addMenuItem('hypometerWidgets', {
      text: 'Hypometer Widgets',
      context: 'insert',
      onAction: _onAction
    })

    editor.ui.registry.addButton('hypometerFuturesWidget', {
      text: 'Hypometer Futures Widget',
      onAction: _futureOnAction
    })

    // Define poll widget
    editor.ui.registry.addButton('sbPollWidget', {
      text: 'Insert Poll',
      onAction: _pollOnAction
    })
  }
}
